import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';
import { NavbarVerticalStyle2Component } from 'app/layout/components/navbar/vertical/style-2/style-2.component';
import { NavigationModule } from 'app/layout/components/navigation/navigation.module';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, FuseSharedModule, NavigationModule, NavbarVerticalStyle2Component],
  exports: [NavbarVerticalStyle2Component],
})
export class NavbarVerticalStyle2Module {}
